import React, { useEffect } from 'react'
import about from "../assets/images/about/about-1.jpg"
import cv from "../assets/cv.pdf"
import aos from 'aos'
import aboutME from "../assets/images/about-me.png"


const About = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])
    return (
        <>
            {/* <!-- Start about Area --> */}
            <div id="about" className="rn-about-area rn-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" data-aos-once="true" className="image-area">
                                <div className="thumbnail">
                                    <img src={aboutME} alt="Personal Portfolio Image" />
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" data-aos-once="true" className="col-lg-7 mt_sm--30">
                            <div className="contant">
                                <div className="section-title text-left">
                                    <span className="subtitle">Visit my portfolio & Hire me</span>
                                    <h2 className="title">About Me</h2>
                                </div>
                                <p className="discription">
                                    My name is Khuram Haseeb. A Full-Stack Web and Mobile Developer with a passion for applying new technologies to provide solutions to global issues. With over 6 years of experience in the service industry, I’ve worked with hundreds of people, developing strong communication skills that will be useful to companies in the tech sector in areas of customer success.
                                   

                                </p>

                                <p className="discription">
                                This experience also makes me a quick learner who can proficiently excel under pressure in a fast-paced environment.

                                </p>
                                <p className="discription">
                                I've delivered 10+ SaaS applications to my clients. A Solid experience in developing E-commerce, CRM, Cloud platforms, social networking apps, news portals, high-load platforms, and facility management platforms.

                                </p>

                                <p className='discription'>
                                In my experience, I can provide you with a consultation on your project, suggest the most suitable variants and design the full architecture from scratch or using your materials as a base.

                                </p>
                               
                                <a className="rn-btn mt-5" href={cv} download><span>DOWNLOAD MY CV</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End about Area --> */}
        </>
    )
}

export default About